module.exports = __webpack_public_path__ + "img/icon_wallet_lock.5edd3a12.svg";